import { QarepaEnumInformation } from '@qarepa/common';

export enum CompanyModulesEnum {
  ABSENCES = 'ABSENCES',
  ABSENCES_APPROVALS = 'ABSENCES_APPROVALS',
  ANNOUNCEMENTS = 'ANNOUNCEMENTS',
  BILLING = 'BILLING',
  CHECKLIST = 'CHECKLIST',
  CHECKS = 'CHECKS',
  CHECKS_ONGOING = 'CHECKS_ONGOING',
  CHECKS_SUMMARY = 'CHECKS_SUMMARY',
  INCIDENCES = 'INCIDENCES',
  REQUEST = 'REQUEST',
  COMPANY = 'COMPANY',
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  DEPARTMENTS = 'DEPARTMENTS',
  EMPLOYEES = 'EMPLOYEES',
  EVALUATION = 'EVALUATION',
  FILE_MANAGER = 'FILE_MANAGER',
  HOLIDAYS = 'HOLIDAYS',
  HOME = 'HOME',
  IMPUTATIONS = 'IMPUTATIONS',
  NOTICES = 'NOTICES',
  PAYMENTS = 'PAYMENTS',
  PLANNING = 'PLANNING',
  PROFILE = 'PROFILE',
  PROJECTS = 'PROJECTS',
  SCHEDULE = 'SCHEDULE',
  SHIFTS = 'SHIFTS',
  TASK = 'TASK',
  TICKETS = 'TICKETS',
  TIME_BANK = 'TIME_BANK',
  USER_PROJECTS = 'USER_PROJECTS',
  USERS = 'USERS',
  WORK_CALENDAR = 'WORK_CALENDAR',
  WORK_CALENDAR_EMPLOYEE = 'WORK_CALENDAR_EMPLOYEE',
  WORK_CALENDAR_WORKPLACE = 'WORK_CALENDAR_WORKPLACE',
  WORK_SHIFT = 'WORK_SHIFT',
  WORKPLACES = 'WORKPLACES',
  WORKSTATION_USERS = 'WORKSTATION_USERS',
  ABSENCES_CONFIG = 'ABSENCES_CONFIG',
  ABSENCES_REQUEST = 'ABSENCES_REQUEST',
  ABSENCES_REPORT = 'ABSENCES_REPORT',
}

export const CompanyModulesAlwaysEnabled = [
  CompanyModulesEnum.COMPANY,
  CompanyModulesEnum.EMPLOYEES,
  CompanyModulesEnum.HOME,
  CompanyModulesEnum.PROFILE,
  CompanyModulesEnum.USERS,
  CompanyModulesEnum.ANNOUNCEMENTS,
  CompanyModulesEnum.TICKETS,
  CompanyModulesEnum.HOLIDAYS,
];

export const CompanyModulesInfo: QarepaEnumInformation<CompanyModulesEnum> = {
  [CompanyModulesEnum.HOME]: {
    name: $localize`Inicio`,
  },
  [CompanyModulesEnum.EMPLOYEES]: {
    name: $localize`Empleados`,
  },
  [CompanyModulesEnum.PROFILE]: {
    name: $localize`Perfil`,
  },
  [CompanyModulesEnum.USERS]: {
    name: $localize`Usuarios`,
  },
  [CompanyModulesEnum.COMPANY]: {
    name: $localize`Empresa`,
  },
  [CompanyModulesEnum.CHECKS]: {
    name: $localize`Fichajes`,
  },
  [CompanyModulesEnum.PROJECTS]: {
    name: $localize`Gestión de Proyectos`,
  },
  [CompanyModulesEnum.USER_PROJECTS]: {
    name: $localize`Proyectos`,
  },
  [CompanyModulesEnum.TASK]: {
    name: $localize`Tareas`,
  },
  [CompanyModulesEnum.IMPUTATIONS]: {
    name: $localize`Imputaciones`,
  },
  [CompanyModulesEnum.ABSENCES]: {
    name: $localize`Permisos y ausencias`,
  },
  [CompanyModulesEnum.ABSENCES_CONFIG]: {
    name: $localize`Configuraciones`,
  },
  [CompanyModulesEnum.ABSENCES_REQUEST]: {
    name: $localize`Solicitudes`,
  },
  [CompanyModulesEnum.ABSENCES_REPORT]: {
    name: $localize`Informes`,
  },
  [CompanyModulesEnum.ABSENCES_APPROVALS]: {
    name: $localize`Pendientes de aprobar`,
  },
  [CompanyModulesEnum.FILE_MANAGER]: {
    name: $localize`Documentos`,
  },
  [CompanyModulesEnum.SHIFTS]: {
    name: $localize`Horarios y turnos`,
  },
  [CompanyModulesEnum.WORK_CALENDAR]: {
    name: $localize`Calendario laboral`,
  },
  [CompanyModulesEnum.WORK_CALENDAR_EMPLOYEE]: {
    name: $localize`Por empleado`,
  },
  [CompanyModulesEnum.WORK_CALENDAR_WORKPLACE]: {
    name: $localize`Por centro de trabajo`,
  },
  [CompanyModulesEnum.EVALUATION]: {
    name: $localize`Evaluaciones`,
  },
  [CompanyModulesEnum.TICKETS]: {
    name: $localize`Soporte técnico`,
  },
  [CompanyModulesEnum.BILLING]: {
    name: $localize`Planes y facturación`,
  },
  [CompanyModulesEnum.PAYMENTS]: {
    name: $localize`Planes y facturación`,
  },
  [CompanyModulesEnum.PLANNING]: {
    name: $localize`Planificación`,
  },
  [CompanyModulesEnum.SCHEDULE]: {
    name: $localize`Horarios`,
  },
  [CompanyModulesEnum.WORK_SHIFT]: {
    name: $localize`Turnos`,
  },
  [CompanyModulesEnum.DEPARTMENTS]: {
    name: $localize`Departamentos`,
  },
  [CompanyModulesEnum.CHECKLIST]: {
    name: $localize`Actividades`,
  },
  [CompanyModulesEnum.ANNOUNCEMENTS]: {
    name: $localize`Anuncios`,
  },
  [CompanyModulesEnum.NOTICES]: {
    name: $localize`Avisos`,
  },
  [CompanyModulesEnum.TIME_BANK]: {
    name: $localize`Balance de horas`,
  },
  [CompanyModulesEnum.CHECKS_SUMMARY]: {
    name: $localize`Consolidados`,
  },
  [CompanyModulesEnum.CHECKS_ONGOING]: {
    name: $localize`Registros`,
  },
  [CompanyModulesEnum.COMPANY_DETAILS]: {
    name: $localize`Datos de la empresa`,
  },
  [CompanyModulesEnum.WORKPLACES]: {
    name: $localize`Centros de trabajo`,
  },
  [CompanyModulesEnum.WORKSTATION_USERS]: {
    name: $localize`Máquina de fichajes`,
  },
  [CompanyModulesEnum.HOLIDAYS]: {
    name: $localize`Festivos`,
  },
  [CompanyModulesEnum.INCIDENCES]: {
    name: $localize`Incidencias`,
  },
  [CompanyModulesEnum.REQUEST]: {
    name: $localize`Solicitudes`,
  },
};
